import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE || "http://backretiro360.us-3.evennode.com";

const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

// normaliza rutas: "turnos" => "/turnos"
const p = (path) => `/${String(path || "").replace(/^\/+/, "")}`;

const getToken = () => localStorage.getItem("token") || "";

const auth = () => {
  const token = getToken();
  return token ? { headers: { token } } : {};
};

const debug =
  String(process.env.REACT_APP_DEBUG_API || "").toLowerCase() === "true";

const logUrl = (url, params) => {
  if (!debug) return;
  console.log("👉 URL:", API.getUri({ url, params }));
};

async function req(method, url, { params, data, signal } = {}) {
  logUrl(url, params);

  try {
    const res = await API.request({
      method,
      url,
      params,
      data,
      signal,
      ...auth(),
    });
    return res.data;
  } catch (err) {
    if (debug) {
      const msg =
        err?.response?.data?.mensaje ||
        err?.response?.data?.message ||
        err?.message;
      console.log("🧯 API ERROR:", msg);
    }
    throw err;
  }
}

/* -------------------------------- TURNOS -------------------------------- */

// ✅ GET /turnos?fecha=2026-03-21&atencion=1&persona=...&activo=true&nombre=...
// Compatibilidad:
// - acepta "personal" o "persona" como argumento
// - envía ambos params por compatibilidad con backend viejo/nuevo
export async function getTurnos(
  {
    fecha = "",
    desde = "",
    hasta = "",
    atencion = "",
    personal = "",
    persona = "",
    activo = true,
    nombre = "",
    signal,
  } = {}
) {
  const params = {};
  const personaId = persona || personal || "";

  if (fecha) params.fecha = fecha;
  if (desde) params.desde = desde;
  if (hasta) params.hasta = hasta;

  if (atencion !== "" && atencion !== null && atencion !== undefined) {
    params.atencion = atencion;
  }

  if (personaId) {
    // compatibilidad con distintas rutas backend
    params.persona = personaId;
    params.personal = personaId;
  }

  if (nombre) params.nombre = nombre;

  if (activo !== "" && activo !== null && activo !== undefined) {
    params.activo = activo;
  }

  const data = await req("GET", p("turnos"), { params, signal });

  return Array.isArray(data)
    ? data
    : Array.isArray(data?.turnos)
    ? data.turnos
    : [];
}

export async function getTurnoById(id, { signal } = {}) {
  const data = await req("GET", p(`turnos/${id}`), { signal });
  return data?.turno ?? data;
}

export async function postTurno(payload, { signal } = {}) {
  return req("POST", p("turnos"), { data: payload, signal });
}

export async function putTurno(id, payload, { signal } = {}) {
  return req("PUT", p(`turnos/${id}`), { data: payload, signal });
}

export async function deleteTurno(id, { signal } = {}) {
  return req("DELETE", p(`turnos/${id}`), { signal });
}

/* ------------------------ TURNOS EN ESPERA (NUEVO) ------------------------ */

// ✅ GET /turnos/en-espera?persona=ID&fecha=2026-03-21
// También acepta "personal" para no romper componentes existentes
export async function getTurnosEnEspera(
  {
    persona = "",
    personal = "",
    fecha = "",
    signal,
  } = {}
) {
  const params = {};
  const personaId = persona || personal || "";

  if (personaId) {
    // compatibilidad con backend viejo/nuevo
    params.persona = personaId;
    params.personal = personaId;
  }

  if (fecha) params.fecha = fecha;

  const data = await req("GET", p("turnos/en-espera"), { params, signal });

  return Array.isArray(data)
    ? data
    : Array.isArray(data?.turnos)
    ? data.turnos
    : [];
}

/* --------------------------- HELPERS ÚTILES EXTRA --------------------------- */

// Traer turnos de una fecha puntual
export async function getTurnosByFecha(fecha, { signal } = {}) {
  return getTurnos({ fecha, signal });
}

// Traer turnos por rango
export async function getTurnosByRango(
  { desde = "", hasta = "", signal } = {}
) {
  return getTurnos({ desde, hasta, signal });
}

// Traer turnos por persona/personal
export async function getTurnosByPersonal(
  { personal = "", persona = "", fecha = "", desde = "", hasta = "", signal } = {}
) {
  return getTurnos({
    personal: personal || persona,
    fecha,
    desde,
    hasta,
    signal,
  });
}

// Traer solo turnos EN ESPERA por persona/personal
export async function getTurnosEnEsperaByPersonal(
  { personal = "", persona = "", fecha = "", signal } = {}
) {
  return getTurnosEnEspera({
    personal: personal || persona,
    fecha,
    signal,
  });
}